import type { Knex } from 'knex'

/**
 * Creates minimal core tables in SQLite :memory: for plugin integration tests.
 * Only includes columns that other tables reference via FK.
 * Call before runGeneratedMigration() in plugin tests.
 */
export async function createCoreTables(db: Knex): Promise<void> {
  if (!await db.schema.hasTable('users')) {
    await db.schema.createTable('users', (t) => {
      t.string('id', 26).primary()
      t.string('name', 100).notNullable()
      t.string('email', 255).notNullable()
      t.string('role', 20).notNullable().defaultTo('user')
      t.timestamps(true, true)
    })
  }

  if (!await db.schema.hasTable('roles')) {
    await db.schema.createTable('roles', (t) => {
      t.string('id', 26).primary()
      t.string('name', 50).notNullable().unique()
      t.text('description').nullable()
      t.string('icon', 100).nullable()
      t.timestamps(true, true)
    })
  }
}
